import React, { useCallback, useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Input,
} from "@mui/material";
import useTranslation from "../../../hooks/useTranslation";
import authStore from "../../../stores/AuthStore";

interface ChangePasswordProps {
  dialogOpen: boolean;
  setDialogOpen: (open: boolean) => void;
}

const ChangePassword = ({ dialogOpen, setDialogOpen }: ChangePasswordProps) => {
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);
  const [newPassword, setNewPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [error, setError] = React.useState("");
  const [success, setSuccess] = React.useState("");

  useCallback(() => {
    setError("");
    setSuccess("");
    setNewPassword("");
    setConfirmPassword("");
  }, [dialogOpen]);

  const handleChangePassword = () => {
    if (newPassword.length < 6 && newPassword.length > 50) {
      setError(t("new-password-not-valid"));
      return;
    }
    if (newPassword !== confirmPassword) {
      setError(t("new-password-not-comply"));
      return;
    }

    setLoading(true);
    setError("");

    authStore
      .changePassword(newPassword)
      .then(() => {
        setLoading(false);
        setSuccess(t("success"));
      })
      .catch((error) => {
        console.error("Change password error:", error);
        setLoading(false);
        setError(t("error"));
      })
      .finally(() => {
        setNewPassword("");
        setConfirmPassword("");
      });
  };

  return (
    <>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        className="adminCaseItemDialog"
      >
        <DialogActions className="dialogActions">
          <Button onClick={() => setDialogOpen(false)} color={"error"}>
            &times;
          </Button>
        </DialogActions>
        <DialogContent className="pt mt">
          <div className="pt pb">
            <Input
              sx={{ minWidth: "240px " }}
              type="password"
              placeholder={t("new-password")}
              fullWidth={true}
              disabled={loading}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>
          <div className="pt pb">
            <Input
              sx={{ minWidth: "240px " }}
              type="password"
              placeholder={t("new-password-validate")}
              fullWidth={true}
              disabled={loading}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
          {error && (
            <div className="pt pb">
              <Alert color="error">{error}</Alert>
            </div>
          )}
          {success && (
            <div className="pt pb">
              <Alert color="success">{success}</Alert>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={handleChangePassword}
            disabled={loading}
          >
            {t("save")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ChangePassword;
